import { FiUser } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const CpfField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    mask="cpf"
    placeholder={field.placeholder || field.label || 'CPF'}
    icon={FiUser}
    disabled={disabled}
    required={field.is_required}
    inputMode="numeric"
  />
);

export default CpfField;
